/* Hypnozan — AJAX cart drawer controller
   Handles: open/close, add-to-cart interception, quantity update,
   line removal, Shopify discounts (automatic + code), free-shipping
   progress bar, subtotal + shipping + total, empty state,
   loading + error handling. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var panel       = drawer.querySelector('.cart-drawer__panel');
  var body        = drawer.querySelector('[data-cart-body]');
  var foot        = drawer.querySelector('[data-cart-foot]');
  var emptyEl     = drawer.querySelector('[data-cart-empty]');
  var loadingEl   = drawer.querySelector('[data-cart-loading]');
  var subtotalEl  = drawer.querySelector('[data-cart-subtotal]');
  var shippingRow = drawer.querySelector('[data-shipping-row]');
  var shippingEl  = drawer.querySelector('[data-cart-shipping]');
  var totalEl     = drawer.querySelector('[data-cart-total]');
  var countLabel  = drawer.querySelector('[data-cart-count-label]');
  var discountsEl = drawer.querySelector('[data-cart-discounts]');
  var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
  var lineTpl     = document.querySelector('[data-cart-line-template]');
  var shipBar     = drawer.querySelector('[data-ship-bar]');
  var shipMsg     = drawer.querySelector('[data-ship-msg]');
  var shipFill    = drawer.querySelector('[data-ship-fill]');

  // Shipping estimate config — read once from the footer's data attrs
  var shipFlat = foot ? (parseInt(foot.getAttribute('data-shipping-flat'), 10) || 0) : 0;
  var freeThreshold = foot ? (parseInt(foot.getAttribute('data-shipping-threshold'), 10) || 0) : 0;

  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  var routes = (window.theme && window.theme.routes) || {};
  var changeUrl = routes.cart_change_url || '/cart/change';
  var addUrl    = routes.cart_add_url    || '/cart/add';
  var cartUrl   = routes.cart_url        || '/cart';

  /* ---------- money formatting ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(
      moneyFormat.indexOf('no_decimals') !== -1 ? 0 : 2
    );
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var num = parts.join('.');
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/g, num);
  }

  /* ---------- open / close ---------- */
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refresh();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function showLoading(on) { if (loadingEl) loadingEl.hidden = !on; }

  /* ---------- render ---------- */
  function render(cart) {
    body.innerHTML = '';

    if (!cart || cart.item_count === 0) {
      if (foot) foot.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      body.hidden = true;
      if (shipBar) shipBar.hidden = true;
      if (countLabel) countLabel.textContent = '';
      updateBubble(0);
      return;
    }

    body.hidden = false;
    if (emptyEl) emptyEl.hidden = true;
    if (foot) foot.hidden = false;
    if (countLabel) countLabel.textContent = '(' + cart.item_count + ')';

    cart.items.forEach(function (item, index) {
      var node = lineTpl.content.cloneNode(true);
      var line = node.querySelector('[data-cart-line]');
      line.setAttribute('data-line-index', index + 1);
      line.setAttribute('data-line-key', item.key);

      var img = node.querySelector('[data-line-image]');
      if (item.image) {
        img.src = item.image.replace(/(\.[^.]*)$/, '_160x$1');
        img.alt = item.product_title;
      } else { img.style.display = 'none'; }

      node.querySelectorAll('[data-line-url]').forEach(function (a) { a.href = item.url; });
      node.querySelector('[data-line-title]').textContent = item.product_title;

      var variantEl = node.querySelector('[data-line-variant]');
      if (item.variant_title && item.variant_title.indexOf('Default') === -1) {
        variantEl.textContent = item.variant_title;
      } else { variantEl.style.display = 'none'; }

      // unit price with compare-at strikethrough
      var priceEl = node.querySelector('[data-line-price]');
      var origEl  = node.querySelector('[data-line-price-orig]');
      priceEl.textContent = formatMoney(item.final_price);
      if (item.original_price > item.final_price) {
        origEl.textContent = formatMoney(item.original_price);
        origEl.hidden = false;
      }

      // line-level discount (automatic / code applied to this item)
      var discEl = node.querySelector('[data-line-discount]');
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
        var names = item.line_level_discount_allocations.map(function (d) {
          return d.discount_application.title + ' (\u2212' + formatMoney(d.amount) + ')';
        });
        discEl.textContent = names.join(', ');
        discEl.hidden = false;
      }

      node.querySelector('[data-qty-input]').value = item.quantity;
      node.querySelector('[data-line-total]').textContent = formatMoney(item.final_line_price);

      body.appendChild(node);
    });

    // subtotal / shipping / total
    // Use cart.items_subtotal_price — same field the free-shipping
    // progress bar uses above, so the two views never disagree. Any
    // discounts (codes, automatic, compare-at) are surfaced separately
    // in the discounts row above; this is the items total the
    // customer sees, plus an estimated shipping line.
    var itemsTotal = cart.items_subtotal_price;

    var shipping = 0;
    if (cart.items.length > 0) {
      shipping = (freeThreshold > 0 && itemsTotal >= freeThreshold) ? 0 : shipFlat;
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(itemsTotal);
    if (shippingEl && shippingRow) {
      // Show the shipping line whenever a flat rate is configured, or
      // when we've earned free shipping (so the customer sees "Free").
      if (shipFlat > 0 || (freeThreshold > 0 && itemsTotal >= freeThreshold)) {
        shippingRow.hidden = false;
        shippingEl.textContent = shipping === 0 ? 'Free' : formatMoney(shipping);
      } else {
        shippingRow.hidden = true;
      }
    }
    if (totalEl) totalEl.textContent = formatMoney(itemsTotal + shipping);

    // cart-level discounts (e.g. order discount codes)
    renderDiscounts(cart);

    // free-shipping bar
    renderShipBar(cart);

    updateBubble(cart.item_count);
  }

  function renderDiscounts(cart) {
    if (!discountsEl) return;
    discountsEl.innerHTML = '';
    var apps = cart.cart_level_discount_applications || [];
    apps.forEach(function (d) {
      var row = document.createElement('div');
      row.className = 'cart-drawer__discount-row';
      row.innerHTML = '<span>\uD83C\uDFF7 ' + d.title + '</span><span>\u2212' +
        formatMoney(d.total_allocated_amount) + '</span>';
      discountsEl.appendChild(row);
    });
    // also surface the total saved if Shopify reports it
    if (cart.total_discount && cart.total_discount > 0 && apps.length === 0) {
      var row = document.createElement('div');
      row.className = 'cart-drawer__discount-row';
      row.innerHTML = '<span>\uD83C\uDFF7 Discount</span><span>\u2212' +
        formatMoney(cart.total_discount) + '</span>';
      discountsEl.appendChild(row);
    }
  }

  function renderShipBar(cart) {
    if (!shipBar) return;
    var threshold = parseInt(shipBar.getAttribute('data-threshold'), 10);
    if (!threshold || threshold <= 0) { shipBar.hidden = true; return; }
    shipBar.hidden = false;
    var total = cart.items_subtotal_price;
    if (total >= threshold) {
      shipMsg.innerHTML = '\uD83C\uDF89 You\u2019ve unlocked <strong>free UK shipping</strong>!';
      shipFill.style.width = '100%';
    } else {
      var remaining = threshold - total;
      shipMsg.innerHTML = 'You\u2019re <strong>' + formatMoney(remaining) +
        '</strong> away from free UK shipping.';
      shipFill.style.width = Math.min(100, (total / threshold) * 100) + '%';
    }
  }

  /* ---------- header bubble ---------- */
  function updateBubble(count) {
    document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---------- server calls ---------- */
  function getCart() {
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refresh() {
    showLoading(true);
    return getCart()
      .then(function (cart) { render(cart); })
      .catch(function () { /* keep last state */ })
      .then(function () { showLoading(false); });
  }

  function changeLine(key, quantity) {
    showLoading(true);
    return fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () { refresh(); })
      .then(function () { showLoading(false); });
  }

  /* ---------- add to cart (intercept product forms) ---------- */
  function ajaxAdd(form, directCheckout) {
    var formData = new FormData(form);
    showLoading(true);
    if (!directCheckout) openDrawer();
    // Forms marked data-clear-cart start from an EMPTY cart, so the buy-box
    // supply tiers can never stack up (picking "1 bottle" after "2+1" adds 1,
    // not 4). Only opt-in forms do this; normal add-to-cart is unaffected.
    var prep = form.hasAttribute('data-clear-cart')
      ? fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }).catch(function () {})
      : Promise.resolve();
    return prep.then(function () { return fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }); })
      .then(function (r) { return r.json().then(function (data) {
        return { ok: r.ok, data: data };
      }); })
      .then(function (res) {
        if (!res.ok) {
          // Shopify returns { description, message } on error
          alert(res.data.description || res.data.message || 'Could not add to cart.');
          showLoading(false);
          return;
        }
        if (directCheckout) {
          // go straight to checkout — do not open the drawer
          window.location.href = '/checkout';
          return;
        }
        return refresh();
      })
      .catch(function () {
        showLoading(false);
        // fall back to a normal navigation if AJAX fails
        form.submit();
      });
  }

  /* ---------- events ---------- */
  // open via header cart icon
  document.querySelectorAll('[data-cart-toggle], .cart-icon').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  // close
  drawer.querySelectorAll('[data-cart-close], [data-cart-overlay]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // checkout
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  // line controls (delegated)
  body.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-qty-input]');
    var qty = parseInt(input.value, 10) || 1;

    if (e.target.closest('[data-qty-up]')) {
      changeLine(key, qty + 1);
    } else if (e.target.closest('[data-qty-down]')) {
      changeLine(key, Math.max(0, qty - 1));
    } else if (e.target.closest('[data-line-remove]')) {
      line.classList.add('is-removing');
      changeLine(key, 0);
    }
  });

  // direct quantity typing
  body.addEventListener('change', function (e) {
    if (!e.target.matches('[data-qty-input]')) return;
    var line = e.target.closest('[data-cart-line]');
    var key = line.getAttribute('data-line-key');
    var qty = parseInt(e.target.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    changeLine(key, qty);
  });

  // intercept all product add-to-cart forms site-wide
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.tagName !== 'FORM') return;
    var isProductForm =
      form.getAttribute('action') &&
      form.getAttribute('action').indexOf('/cart/add') !== -1;
    var hasFormType =
      form.querySelector('input[name="form_type"]') &&
      form.querySelector('input[name="form_type"]').value === 'product';
    if (isProductForm || hasFormType) {
      e.preventDefault();
      // forms marked data-direct-checkout add then go straight to /checkout;
      // all other product forms add via AJAX and open the drawer.
      var directCheckout = form.hasAttribute('data-direct-checkout');
      ajaxAdd(form, directCheckout);
    }
  });

  // expose a manual opener
  window.theme = window.theme || {};
  window.theme.openCartDrawer = openDrawer;
  window.theme.refreshCart = refresh;
})();